/* eslint-disable */
export default {
    cp_filter_menu_organisation: "Organisatie",
    cp_filter_menu_status: "Status",
    cp_filter_menu_suborganisation: "Suborganisatie",
    cp_filter_menu_product: "Product",
    cp_filter_menu_project: "Project",
    cp_filter_menu_date_completed: "Datum afgerond",
    cp_filter_menu_date_added: "Datum toegevoegd",
    cp_filter_menu_to_section: "Naar onderdeel",
    cp_filter_menu_less: "Minder",
    cp_filter_menu_more: "Meer",
    cp_filter_menu_search: "Zoeken...",
    cp_filter_menu_start_date: "Begindatum",
    cp_filter_menu_end_date: "Einddatum",
    cp_filter_menu_could_not_fetch_organisations: "Kan organisaties niet ophalen",
    cp_filter_menu_items_fetch_error: "Er is iets misgegaan bij het ophalen van filter menu items.",
    cp_filter_menu_selected_filters: "Geselecteerde filters:",
    cp_filter_menu_no_results: "Geen resultaten",
    cp_filter_menu_no_filter_selected: "Geen filters geselecteerd",
    cp_filter_menu_planning_filter_to_be_planned: "Nog niet gepland",
    cp_filter_menu_planning_filter_planned: "Ingepland",
    cp_filter_menu_planning_filter_report_in_preparation: "Rapport in voorbereiding",
    cp_filter_menu_planning_filter_report_shared: "Rapport gedeeld",
    cp_filter_menu_consultants: "Adviseurs",
    cp_filter_menu_costHeadings: "Kostenplaats/PO-nummer",
    cp_filter_menu_appointment_date: "Afspraakdatum",
    cp_filter_menu_appointment_date_from: "Van",
    cp_filter_menu_appointment_date_until: "Tot en met",
    cp_filter_menu_assessment_outcome_filter_in_consideration: "In overweging",
    cp_filter_menu_assessment_outcome_filter_positive: "Selectie - aangenomen",
    cp_filter_menu_assessment_outcome_filter_negative: "Selectie - niet aangenomen",
    cp_filter_menu_assessment_outcome_filter_neutral: "Ontwikkelassements",
    cp_filter_menu_assessment_outcome_filter_unknown: "Onbekend",
    cp_filter_menu_outcome: "Resultaat"
};
